import * as React from 'react';
import {StyleProp, ViewStyle} from 'react-native';

interface IProps {
  width?: number;
  style?: StyleProp<ViewStyle>;
}

export default (props: IProps) => {
  const {width: size} = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="17.5" cy="17.5" r="17.5" fill="#0088FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8288 19.6275H26.6278V26.8334H8.61309V19.6275H7.41211V10.0197H11.7549C12.8814 7.8219 15.1236 6.41675 17.6204 6.41675C20.1173 6.41675 22.3607 7.8231 23.486 10.0197H27.8288V19.6275ZM15.887 22.2108V20.2847H17.0426V20.9267H18.1983V20.2847H19.3539V22.2108H15.887ZM17.6204 7.57241C19.4271 7.57241 21.0712 8.4588 22.0505 9.88373H13.1904C14.1697 8.45996 15.8138 7.57241 17.6204 7.57241ZM25.5175 19.5142H9.72343V25.6778H25.5175V19.5142ZM8.56777 11.0394H26.6731V18.3586H8.56777V11.0394Z"
        fill="#F3F9FF"
      />
    </svg>
  );
};
